import { APP_INITIALIZER, EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AnchorScrollService } from './anchor-scroll.service';

export function provideDfUiAnchorScroll(): EnvironmentProviders {
    return makeEnvironmentProviders([
        {
            provide: APP_INITIALIZER,
            useFactory: (anchorScrollService: AnchorScrollService) => () => {
                anchorScrollService.appInitialize();
            },
            deps: [AnchorScrollService],
            multi: true
        }
    ]);
}
